// extracted by mini-css-extract-plugin
export default {"selected":"_1c4c26ee3c","un":"ea8abdad94"};